// extracted by mini-css-extract-plugin
export default {"title":"c83335a942","bld":"_0790b82419"};